import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { useState } from 'react';
import { AppState, Auth0Provider } from '@auth0/auth0-react';

const issuer = process.env.REACT_APP_OKTA_ISSUER;
const redirectUri = process.env.REACT_APP_OKTA_REDIRECT_URI;
const clientId = process.env.REACT_APP_AUTH0_CLIEND_ID;
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientSecret = process.env.REACT_APP_OKTA_CLIENT_SECRET;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

//
// const authProvider: OAuthProvider = new AuthService({
//     issuer,
//     redirect_uri: redirectUri,
//     client_id: clientId,
//     responseType: ['id_token', 'token'],
//     pkce: false,
//     onAuthRequired: onAuthRequired()
// });

// export const logout = async (history: any) => {
//     authProvider._history = history;
//     const authState = authProvider.getAuthState();
//     const authenticated = !authState.isPending && authState.isAuthenticated;
//     if (authenticated) {
//         await authProvider.logout();
//     }
//     else{
//         history.push(ROUTES.login());
//     }
// };

// export default authProvider;

const LrAuthentication: React.FunctionComponent = (props) => {
    const { children } = props;
    const history = useHistory();

    const onRedirectCallback = (appState?: AppState) => {
        history.push(appState?.returnTo || window.location.pathname);
    };

    return (
        <Auth0Provider
            domain={domain || ''}
            clientId={clientId || ''}
            authorizationParams={{ redirect_uri: window.location.origin + '/callback', audience: audience }}
            onRedirectCallback={onRedirectCallback}
        >
            {children}
        </Auth0Provider>
    );
};

export default LrAuthentication;
